import { ObjectBuilder } from "../../graphQlBuilder/ObjectBuilder.js";
import { QueryBuilder } from "../../graphQlBuilder/QueryBuilder.js";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const _GenerateUploadUrlMutationBuilder = class {
  static buildQuery(parameters) {
    return new QueryBuilder().mutation((builder) => {
      for (const alias in parameters) {
        const fileParameters = parameters[alias];
        if (fileParameters.suffix || fileParameters.fileName || fileParameters.extension) {
          builder = builder.object(
            alias,
            _GenerateUploadUrlMutationBuilder.generateUploadUrlFields.argument("input", fileParameters)
          );
        } else {
          builder = builder.object(
            alias,
            _GenerateUploadUrlMutationBuilder.generateUploadUrlFields.argument("contentType", fileParameters.contentType).argument("expiration", fileParameters.expiration).argument("prefix", fileParameters.prefix).argument("acl", fileParameters.acl)
          );
        }
      }
      return builder;
    });
  }
};
let GenerateUploadUrlMutationBuilder = _GenerateUploadUrlMutationBuilder;
__publicField(GenerateUploadUrlMutationBuilder, "generateUploadUrlFields", new ObjectBuilder().name("generateUploadUrl").field("url").field("publicUrl").field("method").object("headers", (builder) => builder.field("key").field("value")));
export {
  GenerateUploadUrlMutationBuilder
};
//# sourceMappingURL=GenerateUploadUrlMutationBuilder.js.map
